/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { Formik } from "formik";
import contactUsValidationSchema from "utils/contactUsValidationSchema";
import { CircularProgress } from "@material-ui/core";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);

const useStyles = makeStyles(styles);

export default function ContactUs() {
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  const [loading, setLoading] = React.useState(true);
  const [initialValues, setInitialValues] = React.useState({
    title: "",
    shortDetails: "",
    address: "",
    emailAddress: "",
    contactNumber: "",
  });
  const [alert, setAlert] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/contactus`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        const data = res.data.data[0];
        setInitialValues({
          title: data?.title || "",
          shortDetails: data?.shortDetails || "",
          address: data?.address || "",
          emailAddress: data?.emailAddress || "",
          contactNumber: data?.contactNumber || "",
        });
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ===
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleSubmit = async (values, setSubmitting) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/contactus`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {res.data.message}
            </span>
          }
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={`${classesSweetAlert.button} ${classesSweetAlert.success}`}
        />
      );
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>

      {!loading ? (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Contact Us</h4>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={contactUsValidationSchema}
                  onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
                >
                  {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Title"
                            id="title"
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              type: "text",
                              value: values.title,
                            }}
                            error={touched.title && Boolean(errors.title)}
                            helperText={
                              touched.title && errors.title
                                ? errors.title
                                : "Please enter the title"
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Short Details"
                            id="shortDetails"
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              type: "text",
                              value: values.shortDetails,
                            }}
                            error={touched.shortDetails && Boolean(errors.shortDetails)}
                            helperText={
                              touched.shortDetails && errors.shortDetails
                                ? errors.shortDetails
                                : "Please enter the short details"
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Address"
                            id="address"
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              type: "text",
                              value: values.address,
                            }}
                            error={touched.address && Boolean(errors.address)}
                            helperText={
                              touched.address && errors.address
                                ? errors.address
                                : "Please enter the address"
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Email Address"
                            id="emailAddress"
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              type: "email",
                              value: values.emailAddress,
                            }}
                            error={touched.emailAddress && Boolean(errors.emailAddress)}
                            helperText={
                              touched.emailAddress && errors.emailAddress
                                ? errors.emailAddress
                                : "Please enter a valid email"
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Contact Number"
                            id="contactNumber"
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                              type: "number",
                              value: values.contactNumber,
                            }}
                            error={touched.contactNumber && Boolean(errors.contactNumber)}
                            helperText={
                              touched.contactNumber && errors.contactNumber
                                ? errors.contactNumber
                                : "Please enter the contact number"
                            }
                          />
                        </GridItem>
                      </GridContainer>

                      <Button type="submit" color="rose" className={classes.registerButton}>
                        Submit
                      </Button>
                    </form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </GridItem>
          {alert}
        </GridContainer>
      ) : (<div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>)}
    </div>
  );
}